var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iconHolder",staticClass:"flex justify-center items-center",domProps:{"innerHTML":_vm._s(require(("../assets/icons/" + _vm.name + ".svg")))}})}
var staticRenderFns = []

export { render, staticRenderFns }